<template>
  <div v-if="hasBadges" class="verification-badges">
    <v-chip v-for="belt in beltKeys" :key="belt" small class="mr-1 mb-1" :color="getColor(belt)" text-color="white">
      <BadgeCheckIcon size="16" class="hero-icon mr-1"></BadgeCheckIcon>
      {{ $t("message." + belt) }}
    </v-chip>
    <v-chip v-if="ibjjfCompetitor" small class="mr-1 mb-1" color="blue" text-color="white"
      @click="goToCompetitor()">
      <BadgeCheckIcon size="16" class="hero-icon mr-1"></BadgeCheckIcon>
      {{ $t("message.ibjjf_verified") }}
    </v-chip>
  </div>
</template>

<script>
import { BadgeCheckIcon } from "@vue-hero-icons/outline";

export default {
  name: "VerificationBadges",
  components: {
    BadgeCheckIcon,
  },
  props: {
    verifiedBelts: {
      type: Object,
      default: null,
    },
    ibjjfCompetitor: {
      type: Object,
      default: null,
    },
  },
  computed: {
    beltKeys() {
      return this.verifiedBelts ? Object.keys(this.verifiedBelts) : [];
    },
    hasBadges() {
      return this.beltKeys.length > 0 || !!this.ibjjfCompetitor;
    },
  },
  methods: {
    goToCompetitor() {
      if (!this.ibjjfCompetitor) return;
      this.navigateTo({
        name: "ibjjfcompetitorsprofile",
        params: { competitorId: this.ibjjfCompetitor._id },
      });
    },
  },
};
</script>
